import { render, staticRenderFns } from "./NewDelet.vue?vue&type=template&id=7db10930&scoped=true"
import script from "./NewDelet.vue?vue&type=script&lang=js"
export * from "./NewDelet.vue?vue&type=script&lang=js"
import style0 from "./NewDelet.vue?vue&type=style&index=0&id=7db10930&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db10930",
  null
  
)

export default component.exports